import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { Icon as u } from "../../icon/icon.js";
import { forwardRef as d } from "react";
import { Text as h } from "../../text/text.js";
import l from "clsx";
import { a as _ } from "../../../virginmediao2-momentum-icons-icons-fas-C-qJ8QLF.js";
import { s as o } from "../../../form-checkbox-group.module-DDbr9U8c.js";
const b = d(
  ({
    label: t,
    isSquare: n = !1,
    isFlag: e = !1,
    isSmall: s = !1,
    isBordered: a = !1,
    error: m = !1,
    isLabelFullWidth: f = !1,
    ...c
  }, p) => /* @__PURE__ */ i(
    "label",
    {
      "data-testid": "form-input-control",
      className: l(o["form-input-control"], {
        [o["form-input-control--is-square"]]: n,
        [o["form-input-control--is-flag"]]: !!e,
        [o["form-input-control--with-label"]]: !!t,
        [o["form-input-control--size-sm"]]: s,
        [o["form-input-control--is-bordered"]]: a,
        [o["form-input-control--is-invalid"]]: !!m,
        [o["form-input-control--is-label-full-width"]]: !!f
      }),
      children: [
        /* @__PURE__ */ i(
          "span",
          {
            "data-testid": "form-input-control-signifier",
            className: o["form-input-control__signifier"],
            children: [
              /* @__PURE__ */ r(
                "input",
                {
                  type: "checkbox",
                  className: o["form-input-control__control"],
                  ...c,
                  ref: p
                }
              ),
              /* @__PURE__ */ r("span", { className: o["form-input-control__icon"], children: /* @__PURE__ */ r(u, { icon: _ }) })
            ]
          }
        ),
        /* @__PURE__ */ r(
          "span",
          {
            "data-testid": "form-input-label",
            className: l(o["form-input-control__label"], {
              [o["form-input-control__label--with-signifier"]]: !0
            }),
            children: /* @__PURE__ */ r(h, { size: "T300", weight: "regular", color: "default", children: t })
          }
        )
      ]
    }
  )
);
b.displayName = "FormCheckboxInput";
export {
  b as FormCheckboxInput,
  b as default
};
